import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>AgroHarvest | Terms of Service</title>
        <meta
          name="description"
          content="Review the terms and conditions of AgroHarvest Machineries."
        />
      </Helmet>
      <TheTerms>
        <div className="page-hero">
          <div className="hero-inner">
            <span className="hero-label">AgroHarvest Machineries — Legal</span>
            <h1>
              Terms of
              <br />
              Service
            </h1>
            <p className="hero-sub">
              Please read these terms carefully before using our services.
            </p>
          </div>
          <div className="hero-rule" />
        </div>

        <div className="page-container">
          <div className="meta-row">
            <span className="section-tag">Effective Date</span>
            <span className="meta-date">January 1, 2024</span>
          </div>

          <div className="content-grid">
            <div className="sections-col">
              <div className="policy-section">
                <span className="section-tag">01</span>
                <h2>Terms and Conditions</h2>
                <p>
                  Welcome to AgroHarvest Machineries. These terms and conditions
                  outline the rules and regulations for the use of our website,
                  located at agroharvestmachineries.com. By accessing this
                  website we assume you accept these terms and conditions. Do
                  not continue to use AgroHarvest Machineries if you do not
                  agree to all of the terms and conditions stated on this page.
                </p>
              </div>

              <div className="policy-section">
                <span className="section-tag">02</span>
                <h2>Terminology</h2>
                <p>
                  The following terminology applies to these Terms and
                  Conditions, Privacy Statement and Disclaimer Notice and all
                  Agreements: "Client", "You" and "Your" refers to you, the
                  person logged on to this website and compliant to the
                  Company's terms and conditions. "The Company", "Ourselves",
                  "We", "Our" and "Us" refers to our Company. "Party",
                  "Parties", or "Us" refers to both the Client and ourselves.
                  All terms refer to the offer, acceptance and consideration of
                  payment necessary to undertake the process of our assistance
                  to the Client in the most appropriate manner, in accordance
                  with and subject to prevailing law of the United States.
                </p>
              </div>

              <div className="policy-section">
                <span className="section-tag">03</span>
                <h2>Cookies</h2>
                <p>
                  We employ the use of cookies. By accessing AgroHarvest
                  Machineries, you agreed to use cookies in agreement with our
                  Privacy Policy. Most interactive websites use cookies to let
                  us retrieve the user's details for each visit. Cookies are
                  used by our website to enable the functionality of certain
                  areas to make it easier for people visiting our website.
                </p>
              </div>

              <div className="policy-section">
                <span className="section-tag">04</span>
                <h2>License and Intellectual Property</h2>
                <p>
                  Unless otherwise stated, AgroHarvest Machineries and/or its
                  licensors own the intellectual property rights for all
                  material on our website. All intellectual property rights are
                  reserved. You may access this site for your own personal use
                  subjected to restrictions set in these terms and conditions.
                </p>
                <p className="list-intro">You must not:</p>
                <ul className="restriction-list">
                  <li>Republish material from AgroHarvest Machineries</li>
                  <li>
                    Sell, rent or sub-license material from AgroHarvest
                    Machineries
                  </li>
                  <li>
                    Reproduce, duplicate or copy material from AgroHarvest
                    Machineries
                  </li>
                  <li>Redistribute content from AgroHarvest Machineries</li>
                </ul>
              </div>

              <div className="policy-section">
                <span className="section-tag">05</span>
                <h2>User Comments</h2>
                <p>
                  Parts of this website offer an opportunity for users to post
                  and exchange opinions and information in certain areas.
                  AgroHarvest Machineries does not filter, edit, publish or
                  review comments prior to their presence on the website.
                  Comments do not reflect the views and opinions of AgroHarvest
                  Machineries, its agents and/or affiliates.
                </p>
                <p>
                  AgroHarvest Machineries reserves the right to monitor all
                  comments and to remove any comments which can be considered
                  inappropriate, offensive or causes breach of these Terms and
                  Conditions.
                </p>
              </div>

              <div className="policy-section">
                <span className="section-tag">06</span>
                <h2>Hyperlinking to Our Content</h2>
                <p>
                  The following organizations may link to our website without
                  prior written approval:
                </p>
                <ul className="standard-list">
                  <li>Government agencies</li>
                  <li>Search engines</li>
                  <li>News organizations</li>
                  <li>Online directory distributors</li>
                </ul>
                <p>
                  These organizations may link to our home page, to publications
                  or to other website information so long as the link is not in
                  any way deceptive, does not falsely imply sponsorship or
                  endorsement, and fits within the context of the linking
                  party's site.
                </p>
              </div>

              <div className="policy-section">
                <span className="section-tag">07</span>
                <h2>Content Liability</h2>
                <p>
                  We shall not be held responsible for any content that appears
                  on your website. You agree to protect and defend us against
                  all claims that arise from your website. No link should appear
                  on any website that may be interpreted as libelous, obscene or
                  criminal, or which infringes or advocates the infringement of
                  any third party rights.
                </p>
              </div>

              <div className="policy-section">
                <span className="section-tag">08</span>
                <h2>Reservation of Rights</h2>
                <p>
                  We reserve the right to request that you remove all links or
                  any particular link to our website. You approve to immediately
                  remove all links to our website upon request. We also reserve
                  the right to amend these terms and conditions and its linking
                  policy at any time. By continuously linking to our website,
                  you agree to be bound to and follow these linking terms and
                  conditions.
                </p>
              </div>

              <div className="policy-section">
                <span className="section-tag">09</span>
                <h2>Disclaimer</h2>
                <p>
                  To the maximum extent permitted by applicable law, we exclude
                  all representations, warranties and conditions relating to our
                  website and the use of this website. Nothing in this
                  disclaimer will:
                </p>
                <ul className="standard-list">
                  <li>
                    Limit or exclude our or your liability for death or personal
                    injury
                  </li>
                  <li>
                    Limit or exclude our or your liability for fraud or
                    fraudulent misrepresentation
                  </li>
                  <li>
                    Limit any of our or your liabilities in any way not
                    permitted under applicable law
                  </li>
                  <li>
                    Exclude any of our or your liabilities that may not be
                    excluded under applicable law
                  </li>
                </ul>
                <p>
                  As long as the website and the information and services on the
                  website are provided free of charge, we will not be liable for
                  any loss or damage of any nature.
                </p>
              </div>
              <div className="policy-section">
                <span className="section-tag">10</span>

                <h2>Product Sales Policy</h2>

                <p>
                  Our company is committed to making farming easier, more
                  efficient, and more sustainable for farmers across the globe
                  by providing access to high-quality agricultural equipment and
                  solutions.
                </p>

                <p>
                  To maintain competitive pricing and support large-scale
                  agricultural supply operations, we primarily generate our
                  profits through high-volume equipment sales and distribution.
                </p>

                <p>
                  As part of our sales structure, certified and authorized
                  dealers may qualify to purchase products below the stated
                  Minimum Order Quantity (MOQ). These special purchasing
                  arrangements are available exclusively to approved dealers,
                  distributors, and recognized procurement partners.
                </p>

                <p>
                  Customers, organizations, or buyers who are not certified or
                  authorized dealers will generally be required to meet the
                  standard MOQ requirements applicable to each product or
                  equipment category.
                </p>

                <ul className="standard-list">
                  <li>
                    Reduced MOQ purchasing may be granted only to verified
                    authorized dealers and certified procurement partners
                  </li>

                  <li>
                    Standard customers and non-authorized buyers are subject to
                    the listed MOQ requirements
                  </li>

                  <li>
                    Product pricing, availability, and MOQ requirements may vary
                    depending on manufacturer policies and supply conditions
                  </li>

                  <li>
                    We reserve the right to verify dealer certifications and
                    procurement credentials before approving discounted or
                    reduced-quantity orders
                  </li>
                </ul>

                <p>
                  Our mission remains focused on supporting farmers and
                  agricultural businesses worldwide by facilitating access to
                  reliable equipment, competitive supply channels, and trusted
                  procurement solutions.
                </p>
              </div>
            </div>

            <div className="sidebar">
              <div className="contact-block">
                <span className="section-tag">Questions?</span>
                <h3>Legal Inquiries</h3>
                <p>
                  If you have any questions about these Terms of Service, please
                  contact us.
                </p>
                <div className="contact-links">
                  <a href="mailto:legal@agroharvest.com">
                    legal@agroharvest.com
                  </a>
                  <a href="tel:+12706320751"> +1-270-632-0751</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TheTerms>
    </>
  );
};

const TheTerms = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f5f2ed;
  font-family: "Georgia", "Times New Roman", serif;
  color: #1c1c1c;

  /* ── HERO ── */
  .page-hero {
    background: var(--primary-color);
    padding: 7rem 6rem 4rem;

    .hero-inner {
      max-width: 900px;

      .hero-label {
        display: block;
        font-family: "Courier New", monospace;
        font-size: 0.75rem;
        letter-spacing: 0.18em;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.45);
        margin-bottom: 2rem;
      }

      h1 {
        font-size: clamp(3rem, 8vw, 6rem);
        font-weight: 400;
        color: #f5f2ed;
        line-height: 1;
        letter-spacing: -0.02em;
        margin: 0 0 1.8rem;
      }

      .hero-sub {
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.5);
        font-style: italic;
        margin: 0;
      }
    }

    .hero-rule {
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.15);
      margin-top: 4rem;
    }
  }

  /* ── CONTAINER ── */
  .page-container {
    max-width: 1100px;
    margin: 0 auto;
    padding: 4rem 4rem 6rem;
  }

  .section-tag {
    display: inline-block;
    font-family: "Courier New", monospace;
    font-size: 0.7rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #7a7265;
    margin-bottom: 0.6rem;
  }

  /* ── META ROW ── */
  .meta-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding-bottom: 2.5rem;
    border-bottom: 1px solid #d5d0c8;
    margin-bottom: 3.5rem;

    .section-tag {
      margin-bottom: 0;
    }

    .meta-date {
      font-family: "Courier New", monospace;
      font-size: 0.78rem;
      letter-spacing: 0.1em;
      color: #3d3d3d;
    }
  }

  /* ── CONTENT GRID ── */
  .content-grid {
    display: grid;
    grid-template-columns: 1fr 280px;
    gap: 6rem;
    align-items: start;
  }

  /* ── POLICY SECTIONS ── */
  .sections-col {
    display: flex;
    flex-direction: column;

    .policy-section {
      padding: 2rem 0;
      border-bottom: 1px solid #d5d0c8;

      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        border-bottom: none;
      }

      h2 {
        font-size: 1.25rem;
        font-weight: 400;
        color: var(--primary-color);
        margin: 0 0 1rem;
        line-height: 1.3;
      }

      p {
        font-size: 0.97rem;
        line-height: 1.82;
        color: #3d3d3d;
        margin: 0;

        & + p {
          margin-top: 0.8rem;
        }
      }

      .list-intro {
        margin-top: 0.8rem;
        font-style: italic;
        color: #555;
      }

      a {
        color: var(--primary-color);
        text-decoration: underline;
        text-underline-offset: 3px;
        transition: opacity 0.2s;
        &:hover {
          opacity: 0.7;
        }
      }

      /* Restriction list (prohibited) */
      .restriction-list {
        list-style: none;
        padding: 0;
        margin: 0.8rem 0 0;
        display: flex;
        flex-direction: column;

        li {
          display: grid;
          grid-template-columns: 20px 1fr;
          gap: 0.8rem;
          padding: 0.7rem 0;
          border-bottom: 1px solid #ede8e0;
          font-size: 0.93rem;
          color: #3d3d3d;
          line-height: 1.5;

          &:last-child {
            border-bottom: none;
          }

          &::before {
            content: "—";
            font-family: "Courier New", monospace;
            font-size: 0.75rem;
            color: #b0a898;
            padding-top: 0.1rem;
          }
        }
      }

      /* Standard list (permitted) */
      .standard-list {
        list-style: none;
        padding: 0;
        margin: 0.8rem 0;
        display: flex;
        flex-direction: column;

        li {
          display: grid;
          grid-template-columns: 20px 1fr;
          gap: 0.8rem;
          padding: 0.6rem 0;
          border-bottom: 1px solid #ede8e0;
          font-size: 0.93rem;
          color: #3d3d3d;
          line-height: 1.5;

          &:last-child {
            border-bottom: none;
          }

          &::before {
            content: "·";
            font-family: "Courier New", monospace;
            font-size: 1.1rem;
            color: var(--primary-color);
            line-height: 1.4;
          }
        }
      }
    }
  }

  /* ── SIDEBAR ── */
  .sidebar {
    position: sticky;
    top: 2rem;

    .contact-block {
      border: 1px solid #d5d0c8;
      padding: 1.8rem;
      background: #fff;

      h3 {
        font-size: 1.1rem;
        font-weight: 400;
        color: var(--primary-color);
        margin: 0 0 0.7rem;
      }

      p {
        font-size: 0.88rem;
        line-height: 1.7;
        color: #666;
        margin: 0 0 1.5rem;
        font-style: italic;
        border-bottom: 1px solid #d5d0c8;
        padding-bottom: 1.5rem;
      }

      .contact-links {
        display: flex;
        flex-direction: column;
        gap: 0.7rem;

        a {
          font-family: "Courier New", monospace;
          font-size: 0.75rem;
          letter-spacing: 0.05em;
          color: var(--primary-color);
          text-decoration: none;
          transition: opacity 0.2s;

          &:hover {
            opacity: 0.65;
          }
        }
      }
    }
  }

  /* ── RESPONSIVE ── */
  @media screen and (max-width: 1024px) {
    .page-hero {
      padding: 5rem 3rem 3rem;
    }
    .page-container {
      padding: 3.5rem 3rem 5rem;
    }
    .content-grid {
      gap: 4rem;
      grid-template-columns: 1fr 240px;
    }
  }

  @media screen and (max-width: 768px) {
    .page-hero {
      padding: 4rem 2rem 2.5rem;
      h1 {
        font-size: 3rem;
      }
    }
    .page-container {
      padding: 3rem 2rem 4rem;
    }
    .content-grid {
      grid-template-columns: 1fr;
      gap: 0;
    }
    .sidebar {
      position: static;
      margin-top: 3rem;
      padding-top: 3rem;
      border-top: 1px solid #d5d0c8;
    }
  }

  @media screen and (max-width: 600px) {
    .page-hero {
      padding: 3rem 1.5rem 2rem;
      h1 {
        font-size: 2.4rem;
      }
      .hero-rule {
        margin-top: 2.5rem;
      }
    }
    .page-container {
      padding: 2.5rem 1.5rem 3rem;
    }
  }

  @media screen and (max-width: 420px) {
    .page-hero {
      padding: 2.5rem 1.2rem 1.8rem;
      h1 {
        font-size: 2rem;
      }
    }
    .page-container {
      padding: 2rem 1.2rem 2.5rem;
    }
  }

  @media screen and (max-width: 350px) {
    .page-hero h1 {
      font-size: 1.7rem;
    }
  }
`;

export default Terms;
